import { literals } from "@/constants/literals";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

export interface CreateGarageButtonsProps {
  isExitGarageForm: boolean;
  continueCapture: (
    event: React.BaseSyntheticEvent<
      Event,
      EventTarget & HTMLFormElement,
      EventTarget
    >,
  ) => void;
  switchFormStep: () => void;
  isValidData: boolean;
}

const CreateGarageButtons = ({
  isExitGarageForm,
  continueCapture,
  switchFormStep,
  isValidData,
}: CreateGarageButtonsProps) => {
  return (
    <div className="py-4 flex flex-col gap-4 border-t border-ib-pt-color-gray-300 md:mx-14 md:items-center lg:mx-[calc((100%-797px)/2)]">
      {!isExitGarageForm ? (
        <div className="px-4 md:capture-button">
          <PrimaryButton
            size="medium"
            label={literals.continue}
            colour="red"
            disabled={!isValidData}
            type="submit"
            onClick={continueCapture}
          />
        </div>
      ) : null}
      {isExitGarageForm ? (
        <div className="px-4 flex flex-col gap-y-4 md:px-0 md:w-full md:flex md:flex-row md:justify-center gap-x-6">
          <div className="md:capture-button">
            <SecondaryButton
              size="medium"
              label={literals.return}
              colour="red"
              onClick={switchFormStep}
            />
          </div>
          <div className="md:capture-button">
            <PrimaryButton
              size="medium"
              label={literals.continue}
              colour="red"
              disabled={!isValidData}
              type="submit"
              onClick={continueCapture}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CreateGarageButtons;
